var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[this.disabled ? 'exit-button disabled' : 'exit-button animated fadeIn delay-1s']},[_vm._v("Exit Game")])}
var staticRenderFns = []

export { render, staticRenderFns }